var Credits,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Credits = (function(_super) {

  __extends(Credits, _super);

  "Application Loading Controller";


  Credits.prototype.el = $("#cmhr-mc-credits");

  Credits.prototype.Open = "open";

  Credits.prototype.Closed = "closed";

  Credits.prototype.station = -1;

  Credits.prototype.elements = {
    "#cmhr-mc-credits-entries": "entries",
    "#cmhr-mc-credits-frame": "frame",
    "#credits-label": "heading"
  };

  function Credits(station) {
    this.error = __bind(this.error, this);

    this.resize = __bind(this.resize, this);

    this.render = __bind(this.render, this);

    this.state = __bind(this.state, this);

    "Render View and Init Elements and Events";
    this.station = station;
    this.el.html(require('views/credits'));
    Credits.__super__.constructor.apply(this, arguments);
    $(window).resize(this.resize);
  }

  Credits.prototype.state = function(to) {
    "Set Component State";
    this.el.attr("data-state", to);
    switch (to) {
      case this.Open:
        console.log("CREDITS OPEN");
        this.el.attr("aria-hidden", "false");
        return this.heading.focus();
      case this.Closed:
        return this.el.attr("aria-hidden", "true");
    }
  };

  Credits.prototype.render = function() {
    return this.resize();
  };

  Credits.prototype.resize = function(e) {
    return this.frame.height($(window).height() - this.frame.position().top - $("#cmhr-desktop-header").height());
  };

  Credits.prototype.error = function(e) {
    this.log("credits::error");
    return this.log("Error: " + e);
  };

  return Credits;

})(Spine.Controller);

module.exports = Credits;
